import { LeaveApplicationTemplateBase } from './LeaveApplicationTemplateBase';
import { LeaveApplicationPDFProps } from './types';
import { getRomanianYearSplitText } from './utils';

export const MixedYearLeaveApplicationPDFTemplate = (
  props: LeaveApplicationPDFProps,
) => {
  const {
    requestYear,
    previousYearDaysUsedForRequest = 0,
    currentYearDaysUsedForRequest = 0,
  } = props;
  const previousYear = requestYear - 1;

  const splitText = `${previousYearDaysUsedForRequest} ${getRomanianYearSplitText(previousYearDaysUsedForRequest)} ${previousYear} și ${currentYearDaysUsedForRequest} ${getRomanianYearSplitText(currentYearDaysUsedForRequest)} ${requestYear}.`;

  return (
    <LeaveApplicationTemplateBase
      {...props}
      splitText={splitText}
      yearQualifier=""
    />
  );
};
